(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('infinite-scroll')) {
    customElements.define(
      'infinite-scroll',
      class InfiniteScroll extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;

          this.grid = this.closest('.collection').querySelector('.product-grid');
          this.countEl = this.querySelector('[data-count]');
          this.barEl = this.querySelector('[data-bar]');
          this.button = this.querySelector('[data-button]');
          this.sentinel = this.querySelector('[data-sentinel]');

          this.nextUrl = this.dataset.nextUrl;
          this.total = parseInt(this.dataset.total, 10) || 0;
          this.loaded = parseInt(this.dataset.loaded, 10) || 0;
          this.buffer = [];
          this.loading = false;

          // Hold this page's out-of-stock products until the last page is loaded
          if (this.nextUrl) this.stash(this.grid);
          this.render();

          this.button.addEventListener('click', () => this.loadNext());
          this.observer = new IntersectionObserver(
            (entries) => entries[0].isIntersecting && this.loadNext(),
            { rootMargin: '300px 0px' }
          );
          this.observer.observe(this.sentinel);
          if (!this.nextUrl) this.finish();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        stash(container) {
          container.querySelectorAll('li[data-oos]').forEach((li) => {
            li.remove();
            this.buffer.push(li);
          });
        }

        async loadNext() {
          if (this.loading || !this.nextUrl) return;
          this.loading = true;
          this.button.hidden = true;
          this.setAttribute('aria-busy', 'true');

          try {
            const url = new URL(this.nextUrl, window.location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url.toString());
            if (!response.ok) throw new Error(response.status);

            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const items = doc.querySelectorAll('#product-grid > li');

            items.forEach((item) => {
              const li = document.importNode(item, true);
              // Remove scroll animation classes so appended items are not stuck invisible
              li.classList.remove('scroll-trigger', 'animate--slide-in');
              li.removeAttribute('data-cascade');
              li.querySelectorAll('img').forEach((img) => img.setAttribute('loading', 'lazy'));

              if (li.hasAttribute('data-oos')) this.buffer.push(li);
              else this.grid.appendChild(li);
            });

            this.loaded += items.length;
            const nextEl = doc.querySelector('infinite-scroll');
            this.nextUrl = nextEl ? nextEl.dataset.nextUrl : '';
          } catch (error) {
            this.button.hidden = false; // let the user retry manually
            this.loading = false;
            this.removeAttribute('aria-busy');
            return;
          }

          this.loading = false;
          this.removeAttribute('aria-busy');
          if (!this.nextUrl) this.finish();
          this.render();

          // Re-check: if the sentinel is still in view, load the next page too
          this.observer.unobserve(this.sentinel);
          this.observer.observe(this.sentinel);
        }

        finish() {
          // All pages loaded: now add the out-of-stock products at the very end
          this.buffer.forEach((li) => {
            li.removeAttribute('data-oos');
            this.grid.appendChild(li);
          });
          this.buffer = [];
          this.loaded = this.total;
          this.observer.disconnect();
          this.sentinel.hidden = true;
          this.button.hidden = true;
        }

        render() {
          const loaded = Math.min(this.loaded, this.total);
          const percent = this.total ? Math.round((loaded / this.total) * 100) : 100;
          this.countEl.textContent = this.dataset.text
            .replace('{loaded}', loaded)
            .replace('{total}', this.total);
          this.barEl.style.width = percent + '%';
          this.barEl.parentElement.setAttribute('aria-valuenow', percent);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
